/**
 * Coerce any value into a renderable string. Firebase RTDB sometimes returns
 * objects where the SPA expected a string (e.g. `live_progress.message` can be
 * either `"Running ADF tests"` or `{step: 4, step_key: "adf", detail: "…"}`).
 * Rendering an object as a React child crashes with React error #31, so every
 * mutable-shape field goes through this helper.
 */
export function safeText(v, fallback = '') {
  if (v == null) return fallback;
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  if (v instanceof Error) return v.message || String(v);
  if (Array.isArray(v)) {
    return v.map((x) => safeText(x, '')).filter(Boolean).join(', ') || fallback;
  }
  if (typeof v === 'object') {
    // Known shapes: extract the most human field.
    if (typeof v.message === 'string') return v.message;
    if (typeof v.detail === 'string') return v.detail;
    if (typeof v.description === 'string') return v.description;
    if (typeof v.text === 'string') return v.text;
    if (typeof v.label === 'string') return v.label;
    if (typeof v.name === 'string') return v.name;
    if (typeof v.title === 'string') return v.title;
    // Fall back to a compact JSON representation so the UI never crashes.
    try {
      return JSON.stringify(v);
    } catch {
      return fallback;
    }
  }
  try {
    return String(v);
  } catch {
    return fallback;
  }
}
